const CoreModule = () => import('@pages/core/Module')
const UserAccount = () => import('@pages/core/userAccount/UserAccountIndex')
const ClientIndex = () => import('@pages/core/clients/Index')
const PersonIndex = () => import('@pages/core/people/Index')
const ProfileIndex = () => import('@pages/core/profiles/Index')
const StructureIndex = () => import('@pages/core/structures/Index')
const UnitIndex = () => import('@pages/core/units/Index')
const UserIndex = () => import('@pages/core/users/Index')
const VehicleIndex = () => import('@pages/core/vehicles/Index')
const UploadVehiclesPage = () => import('@pages/core/vehicles/UploadVehiclesPage')
const VenuesModule = () => import('@pages/core/venues/VenuesModule')
const VenueIndex = () => import('@pages/core/venues/Index')
const UploadStructuresPage = () => import('@pages/core/venues/UploadStructuresPage')
const WorkplaceIndex = () => import('@pages/core/workplaces/Index')
const ResourceTypesIndex = () => import('@pages/resources/resourceTypes/Index')
const GuardsIndex = () => import('@pages/vigilance/guards/GuardsIndex')
const ShiftsIndex = () => import('@pages/vigilance/guards/ShiftsIndex')
const AssignmentsIndex = () => import('@pages/assignments/AssignmentsIndex')
const Faults = () => import('@pages/faults/Faults')
const FaultForm = () => import('@pages/faults/FaultForm')
const FaultTypeForm = () => import('@pages/faults/FaultTypeForm')
const FaultTypes = () => import('@pages/faults/FaultTypes')
const FaultFilters = () => import('@pages/faults/Filters')
const DataManagementIndex = () => import('@pages/core/dataManagement/Index')
const StructureFiles = () => import('@pages/core/structures/StructureFiles')
const PolicyManagementIndex = () => import('@pages/core/privacyManagement/policies/Index')
const AuthorizationManagementIndex = () => import('@pages/core/privacyManagement/authorizations/Index')
const AdminSettingsIndex = () => import('@pages/core/adminSettings/Index')
const LoadVenues = () => import('@pages/core/clients/LoadVenues.vue')
const UsageIndicators = () => import('@pages/core/usageIndicators/Index')
const StructureHistory = () => import('@pages/core/structures/StructureHistory')
const VideoTutorials = () => import('@pages/core/videoTutorials/Index')
const BicyclesIndex = () => import('@pages/core/bicycles/Index')
const WhatsappMessagesReport = () => import('@pages/core/clientReports/whatsappReport/Index.vue')
const EmailMessagesReport = () => import('@pages/core/clientReports/emailReport/Index.vue')
const ImplementationIndicators = () => import('@pages/core/implementationIndicators/Index')
const ClientRequirements = () => import('@pages/core/clientRequirements/Index')
const UploadGuardsPage = () => import('@pages/vigilance/guards/UploadGuardsPage')
const SuppressedEmails = () => import('@pages/core/suppressedEmails/Index')
const PendingRecords = () => import('@pages/core/pendingRecords/Index')
const IntercomCalls = () => import('@pages/core/intercomCalls/Index')
const AccessAuthorizationsIndex = () => import('@pages/internals/accessAuthorizations/administration/Index')
const ModifyMeetingRecord = () => import('@pages/management/council/CouncilMeetingModifyRecord')
const VenueRequirements = () => import('@pages/core/venueRequirements/Index')
const MessagingManagement = () => import('@pages/messaging/Index')

import councilModule from './council'

export default {
    path: 'admin',
    component: CoreModule,
    children: [
        {
            path: 'user-account',
            component: UserAccount,
            name: 'userAccount',
        },
        {
            path: 'clients',
            component: ClientIndex,
            name: 'clients',
        },
        {
            path: 'people',
            component: PersonIndex,
            name: 'people',
        },
        {
            path: 'profiles',
            component: ProfileIndex,
            name: 'profiles',
        },
        {
            path: 'structures',
            component: StructureIndex,
            name: 'structures',
        },
        {
            path: 'structure-files',
            component: StructureFiles,
            name: 'structureFiles',
        },
        {
            path: 'units',
            component: UnitIndex,
            name: 'units',
        },
        {
            path: 'users',
            component: UserIndex,
            name: 'users',
        },
        {
            path: 'vehicles',
            component: VehicleIndex,
            name: 'vehicles',
        },
        {
            path: 'guards',
            component: GuardsIndex,
            name: 'guards',
        },
        {
            path: 'shifts-index',
            component: ShiftsIndex,
            name: 'shiftsIndex',
        },
        {
            path: 'assignments',
            component: AssignmentsIndex,
            name: 'assignments',
        },
        {
            path: 'venues',
            component: VenuesModule,
            children: [
                {
                    path: '/',
                    component: VenueIndex,
                    name: 'venues',
                },
                {
                    path: 'upload',
                    component: UploadStructuresPage,
                    name: 'uploadStructuresPage',
                },
            ],
        },
        {
            path: 'workplaces',
            component: WorkplaceIndex,
            name: 'workplaces',
        },
        {
            path: 'resource-types',
            component: ResourceTypesIndex,
            name: 'resourceTypes',
        },
        {
            path: 'fault-create',
            component: FaultForm,
            name: 'fault-create',
        },
        {
            path: 'faults',
            component: Faults,
            name: 'faults',
        },
        {
            path: ':currentFaultId/fault-edit',
            component: FaultForm,
            name: 'fault-edit',
        },
        {
            path: 'fault-types',
            component: FaultTypes,
            name: 'fault-types',
        },
        {
            path: 'fault-type-create',
            component: FaultTypeForm,
            name: 'fault-type-create',
        },
        {
            path: ':currentFaultTypeId/fault-type-edit',
            component: FaultTypeForm,
            name: 'fault-type-edit',
        },
        {
            path: 'filters',
            component: FaultFilters,
            name: 'filters',
        },
        {
            path: 'data-management',
            component: DataManagementIndex,
            name: 'data-management',
            props: true,
        },
        {
            path: 'policy-management',
            component: PolicyManagementIndex,
            name: 'policyManagement',
        },
        {
            path: 'authorization-management',
            component: AuthorizationManagementIndex,
            name: 'authorizationManagement',
        },
        {
            path: 'admin-settings',
            component: AdminSettingsIndex,
            name: 'adminSettings',
            props: true,
        },
        {
            path: 'load-venues',
            component: LoadVenues,
            name: 'loadVenues',
        },
        {
            path: 'usage-indicators',
            component: UsageIndicators,
            name: 'usageIndicators',
        },
        {
            path: 'structures/:structureId',
            component: StructureHistory,
            name: 'structureHistory',
            props: true,
        },
        {
            path: 'load-vehicles',
            component: UploadVehiclesPage,
            name: 'uploadVehiclesPage',
        },
        {
            path: 'whatsapp-messages-report',
            component: WhatsappMessagesReport,
            name: 'clientMessagesReport',
        },
        {
            path: 'email-messages-report',
            component: EmailMessagesReport,
            name: 'emailMessagesReport',
        },
        { path: 'video-tutorials', component: VideoTutorials, name: 'adminVideoTutorials' },
        {
            path: 'bicycles',
            component: BicyclesIndex,
            name: 'bicycles',
        },
        {
            path: 'implementation-indicators',
            component: ImplementationIndicators,
            name: 'implementationIndicators',
        },
        {
            path: 'client-requirements',
            component: ClientRequirements,
            name: 'requirementIndex',
        },
        {
            path: 'load-guards',
            component: UploadGuardsPage,
            name: 'uploadGuardsPage',
        },
        {
            path: 'suppressed-emails',
            component: SuppressedEmails,
            name: 'suppressedEmails',
        },
        {
            path: 'pending-records',
            component: PendingRecords,
            name: 'pendingRecords',
        },

        {
            path: 'intercom-calls',
            component: IntercomCalls,
            name: 'intercomCallsIndex',
        },
        {
            path: 'access-authorizations',
            component: AccessAuthorizationsIndex,
            name: 'adminAccessAuthorizations',
        },
        {
            path: ':meetingId/modify-meeting-record',
            component: ModifyMeetingRecord,
            name: 'modifyCouncilMeetingRecord',
            props: true,
        },
        {
            path: 'venue-requirements',
            component: VenueRequirements,
            name: 'venueRequirementIndex',
        },
        {
            path: 'messaging-management',
            component: MessagingManagement,
            name: 'messagingManagement',
        },
        councilModule,
        
    ],
}
